/**
 * Anmeldezeile (Musterkatalog M-084 „Intranet lesen“, Design-Guide `anmelde-zeile.md`): ein Event mit Datumsblock, Titel,
 * Meta (Wochentag, Uhrzeit, Ort), Zustandszeile (Abzeichen und Hinweis, z. B. „Plätze frei · 12 von 30 Plätzen belegt“) und
 * der Hauptaktion rechts. Gleiche Zeilenform wie `BestellZeile` (Trennlinie, kein Anker um die ganze Zeile: die
 * Bedienelemente sind eigenständig); der Datumsblock folgt `ListenZeile` (Variante „mit Datumsblock“).
 *
 * Rein darstellend: `aktion` ist der Platz für Knopf und Link des Aufrufers (Anmelden, Abmelden, „Zu meinem Kalender“), die
 * Entscheidung, was angeboten wird, trifft der Aufrufer aus derselben Prüfung wie die Action (r110). `meldung` trägt den Satz
 * am Feld (Ablehnung oder Fehlschlag, r105) unter der Zeile, vom Aufrufer als `Alert` gesetzt.
 *
 * Abweichung AW-100 (3): Eigenbau aus `BestellZeile` und dem Datumsblock von `ListenZeile`, kein Katalogblock 1:1; Wortlaut
 * der Zustandszeile weicht von der Vorschau ab (siehe `docs/ui-preline/abweichungen.json`).
 */
export function AnmeldeZeile({
  datumsblock,
  titel,
  meta,
  zustand,
  aktion,
  meldung,
}: {
  /** Rein visuell (`aria-hidden`): das ausgeschriebene Datum steht in `meta`. */
  datumsblock: { tag: string; monat: string };
  titel: string;
  meta?: React.ReactNode;
  /** Abzeichen und Hinweis (Badge-Bausteine, Text). */
  zustand?: React.ReactNode;
  aktion?: React.ReactNode;
  meldung?: React.ReactNode;
}) {
  return (
    <>
      {/* Preline: data-display/data-display-sub-operational-activity-views/data-display-cat-list-groups/brand-logo-list */}
      <li className="py-3 border-b last:border-b-0 border-line-2">
        <div className="flex gap-x-3">
          <span className="mt-0.5 flex shrink-0 flex-col justify-center items-center w-12 py-1 bg-layer border border-layer-line text-layer-foreground rounded-lg self-start" aria-hidden="true">
            <span className="text-lg font-semibold leading-tight text-foreground">{datumsblock.tag}</span>
            <span className="text-xs uppercase text-muted-foreground-1">{datumsblock.monat}</span>
          </span>
          <div className="grow min-w-0 flex flex-col gap-y-2 sm:flex-row sm:items-start sm:gap-x-4">
            <div className="grow min-w-0">
              <p className="text-sm font-medium text-foreground">{titel}</p>
              {meta && <p className="text-xs text-muted-foreground-1">{meta}</p>}
              {zustand && <div className="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-muted-foreground-1">{zustand}</div>}
            </div>
            {aktion && <div className="flex shrink-0 flex-wrap items-center gap-x-3 gap-y-1 sm:justify-end">{aktion}</div>}
          </div>
        </div>
        {meldung && <div className="mt-2">{meldung}</div>}
      </li>
    </>
  );
}
